import { Component, Inject, inject, PLATFORM_ID } from '@angular/core';
import { SpinnerComponent } from '../components/spinner/spinner.component';
import { NsideIdentityService } from '../../shared/services/auth/nSideIdentityService';
import { UserDataService } from '../../shared/services/userData.service';
import { Router } from '@angular/router';
import { map } from 'rxjs';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { User } from '../../shared/models/contact';

@Component({
  selector: 'redirect',
  standalone: true,
  imports: [
    SpinnerComponent,
    CommonModule
  ],
  templateUrl: './redirect.component.html',
  styleUrl: './redirect.component.css'
})
export class RedirectComponent {
  private readonly nSideIdentityService: NsideIdentityService = inject(NsideIdentityService);
  private readonly userDataService: UserDataService = inject(UserDataService);

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private router: Router
  ) {
  }

  isLoggedIn$ = this.nSideIdentityService.checkAuth().pipe(
    map((authData) => {
      if (isPlatformBrowser(this.platformId)) {
        if (authData.isAuthenticated) {
          const userData: User = authData.userData;
          if (userData.user_data) {
            // Set userData in cookie (serialized to a string)
            // this.cookieService.set('userData', JSON.stringify(userData), { expires: 1 }); // Expires in 1 days
          }

          // Get the returnUrl from query parameters
          const returnUrl = localStorage.getItem("current_route") || '/summary'; // Default to /summary
          this.router.navigate([returnUrl]);
          return true;
        } else {
          // Redirect to unauthorized if not authenticated
          this.router.navigate(['unauthorized']);
          return false;
        }
      }
      return false;
    })
  );

}
